import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PortalAdminService {
  constructor(private authService: MsalService, private http: HttpClient) {
    // Initialize authentication state
    this.initializeAuth();
  }

  private initializeAuth() {
    const accounts = this.authService.instance.getAllAccounts();
    if (accounts.length > 0 && !this.authService.instance.getActiveAccount()) {
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  isPortalAdmin(): Observable<any> {
    return new Observable(subscriber => {
      const checkAuth = setInterval(() => {
        let account = this.authService.instance.getActiveAccount();
        
        if (!account) {
          const accounts = this.authService.instance.getAllAccounts();
          if (accounts.length > 0) {
            account = accounts[0];
            this.authService.instance.setActiveAccount(account);
          }
        }

        if (account) {
          clearInterval(checkAuth);
          const email = account.idTokenClaims?.['email'] || 
                       account.username || 
                       account.idTokenClaims?.['preferred_username'];

          if (email) {
            const cleanEmail = String(email).trim().toLowerCase();
            
            const url = `${environment.apiConfig.uri}/admin/Candidates/GetAdmin?email=${cleanEmail}`;
            this.http.get(url).pipe(
              map((response: any) => {
                if (response && response.data && response.data.isAdmin) {
                  return !!response.data.isAdmin;
                }
                return false;
              }),
              catchError((error) => {
                console.error('Error fetching admin status:', error);
                return of(false);
              })
            ).subscribe(result => subscriber.next(result));
          } else {
            subscriber.next(false);
          }
        }
      }, 500); // Check every 500ms

      return () => clearInterval(checkAuth);
    });
  }

  // New method to get email from token
  getEmailFromToken(): string | null {
    let account = this.authService.instance.getActiveAccount();
    
    if (!account) {
      const accounts = this.authService.instance.getAllAccounts();
      if (accounts.length > 0) {
        account = accounts[0];
        this.authService.instance.setActiveAccount(account);
      }
    }

    if (account) {
      const email = account.idTokenClaims?.['email'] || 
                   account.username || 
                   account.idTokenClaims?.['preferred_username'];
      
      if (email) {
        return String(email).trim().toLowerCase();
      }
    }
    
    return null;
  }
}
